import styled from 'styled-components'
import Image from 'next/image'

import imageUrl from './images/signature.png'

export const Signature = styled(Image).attrs({
  src: imageUrl,
  alt: '',
})`
  display: block;
`
